import { useRef } from "react";

import { CurrencyCode, GeneralCurrencyDto } from "@/core/api/generated/v1";

import { useTenantProfileV2 } from "./entity/tenant/useTenantProfileV2";

const defaultCurrency: GeneralCurrencyDto = {
  code: CurrencyCode.Usd,
  name: CurrencyCode.Usd.toUpperCase(),
};

interface Props {
  /** Fallback to USD if no settings found. */
  useDefault?: boolean;
}

export interface UseCurrentCurrencyV2HookResult {
  /** Whether the result is initialized and ready for usage. */
  isInited: boolean;
  currency: Nil<GeneralCurrencyDto>;
}

/** Returns current currency from tenant or user profile, or default currency. */
export function useCurrentCurrencyV2({
  useDefault = true,
}: Props = {}): UseCurrentCurrencyV2HookResult {
  const tenantProfile = useTenantProfileV2();

  const resultRef = useRef<UseCurrentCurrencyV2HookResult>({
    isInited: false,
    currency: undefined,
  });

  if (!resultRef.current.isInited && tenantProfile.isInited) {
    resultRef.current.isInited = true;
    resultRef.current.currency =
      tenantProfile.profile?.settings?.currency || (useDefault ? defaultCurrency : null);
  }

  return resultRef.current;
}
